import { formatNumberWithSeparators } from '../../../../../utils/number'

import {
  LISTING_PERFORMANCE_DAYS_LABEL_KEY,
  LISTING_PERFORMANCE_METRIC,
  LISTING_PERFORMANCE_METRIC_LABEL_KEY,
} from './RentalPortalListingProfileWidgetPerformance.constants'

export function getListingPerformanceEntityId(listingData) {
  return listingData?.has_been_published ? listingData.id : null
}

export function getIsListingPerformanceWidgetShown({
  isInitiated,
  isPerformanceLoading,
  listingData,
  performance,
}) {
  return (
    !isInitiated ||
    (Boolean(listingData?.has_been_published) &&
      (isPerformanceLoading || Boolean(performance)))
  )
}

export function getListingPerformanceMetrics(performance) {
  return [
    {
      key: LISTING_PERFORMANCE_METRIC.inquiries,
      labelKey:
        LISTING_PERFORMANCE_METRIC_LABEL_KEY[
          LISTING_PERFORMANCE_METRIC.inquiries
        ],
      value: performance?.inquiries,
    },
    {
      key: LISTING_PERFORMANCE_METRIC.viewings,
      labelKey:
        LISTING_PERFORMANCE_METRIC_LABEL_KEY[
          LISTING_PERFORMANCE_METRIC.viewings
        ],
      value: performance?.viewings,
    },
    {
      key: LISTING_PERFORMANCE_METRIC.applications,
      labelKey:
        LISTING_PERFORMANCE_METRIC_LABEL_KEY[
          LISTING_PERFORMANCE_METRIC.applications
        ],
      value: performance?.applications,
    },
    {
      key: LISTING_PERFORMANCE_METRIC.days,
      labelKey: LISTING_PERFORMANCE_DAYS_LABEL_KEY[performance?.days_label],
      value: performance?.days,
    },
  ]
    .filter(metric => metric.labelKey && metric.value != null)
    .map(metric => ({
      ...metric,
      value: formatNumberWithSeparators(metric.value),
    }))
}
